import React from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { PageTitle, Button } from '@cordata/buffet';

import { Table } from '~/components/OutboundReferral';

const OutboundReferralsCollection = () => {
  const history = useHistory();
  const params = useParams();

  const onClick = item =>
    history.push(`/patients/${params.patient_id}/outbound-referrals/${item.attributes.careEventUid}`);

  return (
    <>
      <PageTitle
        action={
          <Button
            outline
            tag={Link}
            to={`/patients/${params.patient_id}/outbound-referrals/add`}
            icon="plus"
          >
            Add Outbound Referral
          </Button>
        }
      >
        Outbound Referrals
      </PageTitle>

      <Table
        params={{
          patient_uid: params.patient_id,
        }}
        onClick={onClick}
      />
    </>
  );
};

export default OutboundReferralsCollection;
